function cov_2afhxq6aqm() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Obo.tsx";
  var hash = "810773d174a7407ae050ea58d2de03c119493c8d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Obo.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 43
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "810773d174a7407ae050ea58d2de03c119493c8d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2afhxq6aqm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2afhxq6aqm();
var Icon = (cov_2afhxq6aqm().s[0]++, {
  name: 'obo',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.1068 0.36996C11.6001 -0.12332 12.3999 -0.12332 12.8932 0.369959L14.0021 1.47892L15.4409 0.854792C16.0808 0.577166 16.8247 0.870912 17.1023 1.51089L17.8394 3.20997H19.6794C20.377 3.20997 20.9426 3.77549 20.9426 4.47309V6.01067L22.3139 6.55221C22.9628 6.80843 23.281 7.54213 23.0248 8.19098L22.3707 9.84747L23.63 11.1068C24.1233 11.6001 24.1233 12.3999 23.63 12.8932L22.5211 14.0021L23.1452 15.4409C23.4228 16.0809 23.1291 16.8247 22.4891 17.1024L20.9426 17.7733V19.3683C20.9426 20.066 20.377 20.6315 19.6794 20.6315H18.1122L17.4478 22.3139C17.1916 22.9628 16.4579 23.2811 15.809 23.0248L14.1525 22.3707L12.8932 23.63C12.3999 24.1233 11.6001 24.1233 11.1068 23.63L9.99789 22.5211L8.55912 23.1452C7.91914 23.4229 7.17527 23.1291 6.89765 22.4891L6.09179 20.6315H4.16199C3.46439 20.6315 2.89887 20.0659 2.89887 19.3683V17.9267L1.68605 17.4478C1.03721 17.1916 0.718928 16.4579 0.975151 15.809L1.6293 14.1525L0.36996 12.8932C-0.12332 12.3999 -0.12332 11.6001 0.369959 11.1068L1.47891 9.99789L0.854771 8.55914C0.577146 7.91916 0.870892 7.17529 1.51087 6.89767L2.89887 6.29555V4.47309C2.89887 3.77549 3.46438 3.20997 4.16199 3.20997H5.95041L6.55219 1.68608C6.80841 1.03723 7.54211 0.718951 8.19096 0.975174L9.84748 1.62932L11.1068 0.36996ZM8.62869 14.3364L7.61187 15.7385C7.56135 15.808 7.56767 15.9027 7.63714 15.9658C8.45185 16.8058 9.51287 17.3426 10.7507 17.5511V19.0226C10.7507 19.1552 10.8581 19.2626 10.9907 19.2626H12.6896C12.8222 19.2626 12.9296 19.1552 12.9296 19.0226V17.5826C15.2474 17.2479 16.1 15.7259 16.1 14.2859C16.1 11.9187 13.9548 11.3686 12.2311 10.9266L12.2286 10.926C11.0981 10.6355 10.1192 10.3829 10.1192 9.71971C10.1192 9.05658 10.7444 8.61448 11.6728 8.61448C12.7907 8.61448 13.8075 9.01868 14.5401 9.75129C14.5717 9.78919 14.6222 9.80182 14.6727 9.80182C14.7232 9.7955 14.7675 9.77024 14.799 9.73235L15.8158 8.39343C15.8664 8.32396 15.86 8.22923 15.7969 8.16607C15.0327 7.41451 14.0538 6.93453 12.9233 6.75138V5.29248C12.9233 5.15985 12.8159 5.05248 12.6833 5.05248H10.9844C10.8518 5.05248 10.7444 5.15985 10.7444 5.29248V6.77664C9.03919 7.124 7.92133 8.29239 7.92133 9.85866C7.92133 12.1434 9.99008 12.6684 11.6568 13.0914L11.6602 13.0922L11.6905 13.1C12.8837 13.4061 13.9022 13.6673 13.9022 14.4564C13.9022 15.0564 13.4096 15.7006 12.0265 15.7006C10.3465 15.7006 9.2792 14.7406 8.90026 14.3238C8.86237 14.2859 8.81184 14.2669 8.76132 14.2669C8.70448 14.2669 8.66027 14.2922 8.62869 14.3364Z\" fill=\"currentColor\"/>"
});
export default Icon;